module.exports = __webpack_public_path__ + "img/3.cb1755c1.svg";